import './Comment.css';

export default function Comment({comment}) {
    return (
        <div className="comment">
            <div className="comment-header">
                <h4>{comment.createdBy}</h4>
                <p>{comment.createdDate}</p>
            </div>
            <p>{comment.commentText}</p>
        </div>
    )
}